import { render } from "./ModalImpersonationUserCreate.vue?vue&type=template&id=051f49c5"
import script from "./ModalImpersonationUserCreate.vue?vue&type=script&lang=js"
export * from "./ModalImpersonationUserCreate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__